import { useQuery } from '@tanstack/react-query';
import type { PublicMarketplaceCategory } from '../types';
import * as Api from '../api';

export const usePublicCategories = (options?: { enabled?: boolean }) => {
  return useQuery<{ data: PublicMarketplaceCategory[] }>({
    queryKey: ['public-test-categories'],
    queryFn: async () => {
      const res = await Api.PublicCategories();
      return res.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes cache
    enabled: options?.enabled ?? true,
  });
};

export default usePublicCategories;
